import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import './Paragraph.scss';

export default function Paragraph({ content, idFM, bold, badge }) {
  return (
    <>
      <p style={bold ? { fontWeight: 'bold' } : {}}>
        <FormattedMessage id={idFM} defaultMessage={content} />
        {badge && <span className="Widget__badge">{badge}</span>}
      </p>
    </>
  );
}

Paragraph.propTypes = {
  content: PropTypes.string,
  idFM: PropTypes.string,
  bold: PropTypes.bool,
  badge: PropTypes.string,
};

Paragraph.defaultProps = {
  bold: false,
  badge: undefined,
};
